// extracted by mini-css-extract-plugin
export var primitiveLabel = "_v4-0";